export const convertTimestampToSeconds = (timestamp: string): number => {
    if (!/^(?:(\d{1,2}):)?([0-5]?\d):([0-5]?\d)$/.test(timestamp)) {
        throw new Error(
            'Invalid timestamp format. Expected format: "HH:MM:SS" or "MM:SS" with valid time values.',
        );
    }
    const parts = timestamp.split(':').map(Number).reverse();
    return parts.reduce(
        (acc, part, index) => acc + part * Math.pow(60, index),
        0,
    );
};
